(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pebble-product-batch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pebble-session-gift')) {
    customElements.define('pebble-session-gift', class extends HTMLElement {
      connectedCallback() {
        // Defer until children exist, including Theme Editor section replacements.
        queueMicrotask(() => {
          const integer = (value, fallback) => Number.isFinite(Number(value)) && value !== '' ? Math.floor(Number(value)) : fallback;
          const total = Math.max(1, integer(this.dataset.total, 100));
          const a = Math.min(total, Math.max(1, integer(this.dataset.min, 5)));
          const b = Math.min(total, Math.max(1, integer(this.dataset.max, 10)));
          const min = Math.min(a, b);
          const max = Math.max(a, b);
          const key = ['foxchill-gift-v1', this.dataset.product, this.dataset.block, min, max, total].join(':');
          // Memory fallback keeps rerenders stable when browser storage is unavailable.
          const cache = window.pebbleGiftSessionValues ||= new Map();
          let count = cache.get(key);
          try {
            const saved = sessionStorage.getItem(key);
            if (saved !== null) count = Number(saved);
          } catch {}
          if (!Number.isInteger(count) || count < min || count > max) {
            count = min + Math.floor(Math.random() * (max - min + 1));
          }
          cache.set(key, count);
          try { sessionStorage.setItem(key, String(count)); } catch {}
          const message = this.querySelector('[data-gift-message]');
          if (message) message.textContent = message.dataset.template.replaceAll('[count]', String(count));
          const progress = this.querySelector('progress');
          if (progress) { progress.max = total; progress.value = count; }
          this.dataset.giftCount = String(count);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
